module.exports = __webpack_public_path__ + "images/smartInsightsPoster.d4b209acb514f7abf592d4e55972617c.png";